// @flow
import * as React from 'react';
import Modal from 'react-modal';

import AdminNewAutoMessageSftpCredentialsFormContainer from './AdminNewAutoMessageSftpCredentialsFormContainer';
import AdminAutoMessageSftpCredentialsFormContainer from './AdminAutoMessageSftpCredentialsFormContainer';
import AdminNewAutoMessageSftpCredentialsForm from './AdminNewAutoMessageSftpCredentialsForm';
import AdminAutoMessageSftpCredentialsForm from './AdminAutoMessageSftpCredentialsForm';
import ConfirmDialog from 'components/ConfirmDialog';
import Dialog from 'components/Dialog';

import type { AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials } from 'admin/components/AdminAutoMessageSftpCredentials/queries/__generated__/AdminAutoMessageSftpCredentials';

type Props = {
  credentials: ?AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials,
  orgUuid: ?string,
  onClose: () => void,
  onCredentialGeneration?: (
    sftpCredentials: AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials
  ) => void,
};

type State = {
  newCredentialsHaveBeenGenerated: boolean,
  showNewCredentialConfirmationDialog: boolean,
};

class AdminAutoMessageSftpCredentialsModal extends React.Component<Props, State> {
  state = {
    newCredentialsHaveBeenGenerated: false,
    showNewCredentialConfirmationDialog: false,
  };

  toggleNewCredentialConfirmationDialog = () => {
    this.setState({
      showNewCredentialConfirmationDialog: !this.state.showNewCredentialConfirmationDialog,
    });
  };

  handleDialogDismiss = () => {
    if (this.state.newCredentialsHaveBeenGenerated) {
      this.toggleNewCredentialConfirmationDialog();
      return;
    }

    this.props.onClose();
  };

  handleCredentialsGeneration = (
    sftpCredentials: AdminAutoMessageSftpCredentials_autoMessaging_sftpCredentials
  ) => {
    const { onCredentialGeneration } = this.props;
    if (onCredentialGeneration) {
      onCredentialGeneration(sftpCredentials);
    }
    this.setState({ newCredentialsHaveBeenGenerated: true });
  };

  render() {
    const { credentials, orgUuid } = this.props;

    if (!orgUuid) {
      console.error('AdminAutoMessageSftpCredentialsModal - tried to render without an orgUuid');
      return null;
    }

    const existingCredentialsForm = (
      <AdminAutoMessageSftpCredentialsFormContainer orgUuid={orgUuid} sftpCredentials={credentials}>
        {props => (
          <AdminAutoMessageSftpCredentialsForm
            sftpCredentials={credentials}
            onClose={this.props.onClose}
            orgUuid={orgUuid}
            {...props}
          />
        )}
      </AdminAutoMessageSftpCredentialsFormContainer>
    );
    const newCredentialsForm = (
      <AdminNewAutoMessageSftpCredentialsFormContainer
        orgUuid={orgUuid}
        onCredentialGeneration={this.handleCredentialsGeneration}>
        {props => <AdminNewAutoMessageSftpCredentialsForm {...props} />}
      </AdminNewAutoMessageSftpCredentialsFormContainer>
    );
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.showNewCredentialConfirmationDialog}
          data-test="new-credentials-confirm-modal">
          <ConfirmDialog
            data-test="new-credentials-confirm-dialog"
            title="Are you sure you want to close?"
            actionButtonText="Close"
            cancelButtonText="Cancel"
            onRequestHide={() => this.toggleNewCredentialConfirmationDialog()}
            onConfirm={this.props.onClose}>
            For greater security, your password is only shown once. It’ll be hidden when you return
            to this page.
          </ConfirmDialog>
        </Modal>
        <Dialog
          data-test="main-credentials-dialog"
          size="large"
          onDialogDismiss={this.handleDialogDismiss}
          title={credentials ? 'View credentials' : 'Generate a new set of credentials'}>
          {credentials ? existingCredentialsForm : newCredentialsForm}
        </Dialog>
      </React.Fragment>
    );
  }
}

export default AdminAutoMessageSftpCredentialsModal;
